import React from 'react';
import {withStyles} from '@material-ui/core/styles';

import Layout from '../../components/Layout';
import Toolbar from '../../components/Toolbar/Toolbar';
import i18n from '../../i18n';
import Grid from '@material-ui/core/Grid/Grid';
import HistoryListItem from '../../components/History/ListItem.jsx';
import Table from '@material-ui/core/Table/Table';
import TableBody from '@material-ui/core/TableBody/TableBody';
import Paper from '@material-ui/core/Paper/Paper';
import TableHead from '@material-ui/core/TableHead/TableHead';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TableRow from '@material-ui/core/TableRow/TableRow';
import {FormattedDate} from 'react-intl';

const HistoryShow = ({classes, histories, url, name}) => {
    return (
        <Layout>
            <Toolbar
                disableGutters
                title={i18n.get('history.title_of', {name})}
                items={[
                    {icon:"card_travel", href: url, text: i18n.get('history.open_of', {name})},
                ]}
            />

            <Paper className={classes.layout}>
                <Grid container spacing={24}>
                    <Grid item sm={12}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{i18n.get('history.change_note')}</TableCell>
                                    <TableCell>{i18n.get('history.change_user')} / {i18n.get('history.change_date')}</TableCell>
                                    <TableCell className={classes.columnCenter}>{i18n.get('history.changes')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {histories && histories.map((history, idx) => (
                                        <HistoryListItem
                                            key={idx}
                                            history={history}
                                        />
                                    ),
                                )}
                            </TableBody>
                        </Table>
                    </Grid>
                </Grid>
            </Paper>
        </Layout>
    );
};

const styles = theme => ({
    layout: {
        width: 'auto',
        padding: theme.spacing.unit * 2,
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
    },
    columnCenter: {
        textAlign: 'center',
    },
});

export default withStyles(styles)(HistoryShow);
